import type { SVGProps } from 'react'

export default function ArrowRightSolid(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="18" height="19" viewBox="12.9666 12.1073 18.0405 18.3848" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M30.6602 20.6159C31.0071 21.0414 30.982 21.6691 30.5854 22.0657L22.159 30.4921L20.627 28.96L27.2041 22.3829L12.9667 22.3829L12.9666 20.2165L27.2041 20.2164L20.627 13.6393L22.159 12.1073L30.5854 20.5336L30.6602 20.6159Z"
				fill="currentColor"
			/>
		</svg>
	)
}
